import {
	Box,
	Image,
	HStack,
	Text,
	Center,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	VStack,
	ModalFooter,
	Button,
} from "@chakra-ui/react";
import { useState } from "react";
import TransparentRoundedClose from "../icons/TransparentRoundedClose";

interface Props {
	fileName: string;
	fileUrl: string;
	onRemove?: (url: string) => void;
}

const FileThumbnail = ({ fileName, fileUrl, onRemove }: Props) => {
	const [deleteConfirmModalVisible, setDeleteConfirmModalVisible] = useState<boolean>(false);

	return (
		<Box w="fit-content" bg={onRemove ? "accent.500" : "#FFF"} border={"1px solid #E6E6E6"} px={2} borderRadius={"10px"}>
			<HStack fontSize={"14px"} fontWeight={400} color={onRemove ? "#FFF" : "accent.500"}>
				{fileUrl.endsWith(".jpg") || fileUrl.endsWith(".png") || fileUrl.endsWith(".jpeg") ? (
					<Image
						src={fileUrl}
						alt={`Thumbnail ${fileName}`}
						width={35}
						height={35}
						objectFit={"cover"}
						borderRadius={"4px"}
					/>
				) : fileUrl.endsWith(".pdf") ? (
					<embed src={fileUrl} width="35" height="35" />
				) : (
					<Text>{fileName}</Text>
				)}
				<Text>{fileName}</Text>
				{onRemove && (
					<TransparentRoundedClose
						style={{ marginLeft: "5px", cursor: "pointer" }}
						onClick={() => setDeleteConfirmModalVisible(true)}
					/>
				)}
			</HStack>

			<Modal size={"xl"} isOpen={deleteConfirmModalVisible} onClose={() => setDeleteConfirmModalVisible(false)}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader textAlign={"center"}>Ta bort dokument?</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Text textAlign={"center"}>{`Är du säker på att du vill ta bort dokumentet?`}</Text>
					</ModalBody>

					<ModalFooter>
						<VStack width={"100%"}>
							<Button
								borderRadius={"2px"}
								_hover={{ background: "#4e7da7bd" }}
								bg="accent.500"
								color={"#FFFFFF"}
								width={"100%"}
								mx={3}
								onClick={() => {
									onRemove && onRemove(fileUrl);
									setDeleteConfirmModalVisible(false);
								}}
							>
								Ja, ta bort
							</Button>
							<Button
								borderRadius={"2px"}
								onClick={() => setDeleteConfirmModalVisible(false)}
								width={"100%"}
								mx={3}
								variant="ghost"
							>
								Nej
							</Button>
						</VStack>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</Box>
	);
};

export default FileThumbnail;
